import { useEffect } from "react";
import { getCalApi } from "@calcom/embed-react";

export default function CalWidget() {
    useEffect(() => {
        (async () => {
            const cal = await getCalApi({ namespace: "professional-conversation" });

            // Floating button config
            cal("floatingButton", {
                calLink: "ashutoshshashi/professional-conversation",
                config: {
                    layout: "month_view",
                },
                hideButtonIcon: false,
                buttonPosition: "bottom-right",
                buttonColor: "#be3b3b",
                buttonTextColor: "#ffffff",
                buttonText: "Schedule a Call",
            });

            // Optional UI config for popup
            cal("ui", {
                hideEventTypeDetails: true,
                layout: "month_view",
            });
        })();
    }, []);

    // Nothing to render — Cal injects the floating button itself
    return null;
}
